import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@saviynt/design-system';
import useStyles from './styles/FilterBar.styles';
import { UI_LABELS } from '../../constants/stringConstants';

function FilterBar({ 
  searchTerm, 
  onSearchChange, 
  statusFilter, 
  onStatusChange, 
  sortBy, 
  onSortByChange, 
  sortOrder, 
  onSortOrderChange,
  filteredCount,
  totalCount,
  showStatusFilter,
  showSorting = true,
}) {
  const classes = useStyles();
  
  return (
    <div className={classes.container}>
      <div className={classes.searchContainer}>
        <Icon kind='Search' size='small' className={classes.searchIcon} />
        <input
          type="text"
          placeholder="Search objects..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className={classes.searchInput}
        />
        {searchTerm && (
          <button type="button" className={classes.clearButton} onClick={() => onSearchChange('')}>
            <Icon kind='Close' size='small' />
          </button>
        )}
      </div>

      {showStatusFilter && <div className={classes.selectWrapper}>
        <Icon kind='Filter' size='small' className={classes.selectIcon} />
        <select
          value={statusFilter}
          onChange={(e) => onStatusChange(e.target.value)}
          className={classes.select}
        >
          <option value="all">{UI_LABELS.ALL_STATUS}</option>
          <option value="ready">{UI_LABELS.READY_TO_MIGRATE}</option>
          <option value="completed">{UI_LABELS.COMPLETED}</option>
          <option value="failed">{UI_LABELS.FAILED}</option>
        </select>
      </div>}
      
      {showSorting && (
        <div className={classes.sortContainer}>
          <div className={classes.selectWrapper}>
            <Icon kind='Sort' size='small' className={classes.selectIcon} />
            <select
              value={sortBy}
              onChange={(e) => onSortByChange(e.target.value)}
              className={classes.select}
            >
              <option value="name">{UI_LABELS.SORT_BY_NAME}</option>
              <option value="created">{UI_LABELS.SORT_BY_CREATED}</option>
              <option value="modified">{UI_LABELS.SORT_BY_MODIFIED}</option>
            </select>
          </div>
          <button
            type="button"
            onClick={() => onSortOrderChange(sortOrder === 'asc' ? 'desc' : 'asc')}
            className={classes.sortButton}
            title={sortOrder === 'asc' ? 'Ascending' : 'Descending'}
          >
            <Icon kind={sortOrder === 'asc' ? 'ArrowUp' : 'ArrowDown'} size='small' />
          </button>
        </div>
      )}

      <div className={classes.count}>
        <Icon kind='List' size='small' className={classes.countIcon} />
        {filteredCount} <span className={classes.countMuted}>of {totalCount} objects</span>
      </div>
    </div>
  );
}

FilterBar.propTypes = {
  searchTerm: PropTypes.string,
  onSearchChange: PropTypes.func,
  statusFilter: PropTypes.string,
  onStatusChange: PropTypes.func,
  sortBy: PropTypes.string,
  onSortByChange: PropTypes.func,
  sortOrder: PropTypes.string,
  onSortOrderChange: PropTypes.func,
  filteredCount: PropTypes.number,
  totalCount: PropTypes.number,
  showStatusFilter: PropTypes.bool,
  showSorting: PropTypes.bool,
};

FilterBar.defaultProps = {
  searchTerm: '',
  onSearchChange: undefined,
  statusFilter: 'all',
  onStatusChange: undefined,
  sortBy: 'name',
  onSortByChange: undefined,
  sortOrder: 'asc',
  onSortOrderChange: undefined,
  filteredCount: 0,
  totalCount: 0,
  showStatusFilter: false,
  showSorting: true,
};

export default FilterBar;
